// extracted by mini-css-extract-plugin
export default {"navIllustration":"si6yUVM1"};